import { z } from 'zod';

export const configurationProfileSchema = z.object({
  name: z.string(),
  numberOfAssignedGroups: z.number(),
  id: z.number(),
  isVehicleGroupDefault: z.boolean(),
  syncIntervalConfigurationSettings: z.number(),
  outOfRouteThreshold: z.number(),
});

export const configurationProfilesSchema = z.array(configurationProfileSchema);

export type ConfigurationProfile = z.infer<typeof configurationProfileSchema>;
